import { FormattedMessage } from 'react-intl';
import { Box, Flex, Text } from '@theme-ui/components';

import StatusIcon from '@app/components/StatusIcon';

import messages from './WhatsNewForMe.messages';

type NoUpgradesPropsType = {
  includedProductsUrl: string;
};

const NoUpgrades = ({ includedProductsUrl }: NoUpgradesPropsType) => {
  return (
    <Flex sx={{ textAlign: 'center', flexDirection: 'column' }}>
      <Box mb={3} sx={{ justifySelf: 'center' }}>
        <StatusIcon type="error" fill="currentColor" />
      </Box>

      <Box mb={4} sx={{ fontWeight: '600' }}>
        <FormattedMessage {...messages.noUpgrades} />
      </Box>

      <Box>
        <FormattedMessage
          {...messages.productsIncluded}
          values={{
            productsIncludedLink: (
              <Text sx={{ fontWeight: 500 }}>
                <a href={includedProductsUrl}>
                  <FormattedMessage {...messages.productsIncludedLink} />
                </a>
              </Text>
            ),
          }}
        />
      </Box>
    </Flex>
  );
};

export default NoUpgrades;
